import React, { useState, useEffect } from 'react';

interface TimerProps {
  targetTime: Date; 
}

const IndentTimer: React.FC<TimerProps> = ({ targetTime }) => {
    
  const calculateTimeLeft = () => {
    const difference = targetTime.getTime() - new Date().getTime();

    if (difference <= 0) {
      return null; // Stop countdown when time is up
    }

    return {
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    if (!timeLeft) return; // Stop updates when time is up

    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  }, [timeLeft]);

  return (
    <div>
      {timeLeft ? (
        <div className='d-flex col-12'>
          <div className="col-10" style={{ color: "blue", fontWeight: "bold", fontSize: "14px" }}>
            {timeLeft.hours > 0 ? `${timeLeft.hours} மணிநேரம் ` : ""} 
            {timeLeft.minutes > 0 ? timeLeft.minutes : "00"} நிமிடங்கள்{" "}
            [ {timeLeft.seconds} ] வினாடிகள் உள்ளது.
          </div>
          <div className="col-2">
            <span style={{ color: "red", fontWeight: "bold", float: 'right' }}>
              Close Time: {targetTime.toLocaleTimeString()}
            </span>
          </div>
        </div>
      ) : (
        <div>
          <span>நேரம் முடிந்துவிட்டது!</span>
          <button className='btn-primary btn search-btn'>Close</button>
        </div>
      )}
    </div>
  );
};


export default IndentTimer;
